import { h, toChildArray } from 'preact'
import classNames from 'clsx'

import { getDisplayName } from '../../utils'

import styles from './index.module.scss'

export function AsSeparatedList(Component, displayName) {
  const WrappedComponent = props => {
    const { children, ...rest } = props
    const className = buildClassNames(props)
    const childArray = toChildArray(children)

    if (childArray.length <= 1) {
      return <Component {...props} className={className} />
    }

    return (
      <Component {...rest} className={className}>
        {childArray.map((child, idx, arr) => (
          <span
            key={`sl_${idx}_${arr.length}`}
            className={styles['a-separated-list__entry']}
          >
            {child}
          </span>
        ))}
      </Component>
    )
  }

  WrappedComponent.displayName = displayName || `AsSeparatedList(${getDisplayName(Component)})`

  return WrappedComponent
}

const SeparatedList = AsSeparatedList('div', 'SeparatedList')

function buildClassNames({ className }) {
  return classNames(
    className,
    styles['a-separated-list'],
  )
}

export default SeparatedList
